/**
 * Create a function to add to resolvedPropertyMappings with a key and its resolved value
 * The key should look like this: providerComponent@providerProp
 * @param resolvedMappings
 * @returns {(function(*, *): void)|*}
 */
export default function createAddResolvedPropertyMappingWithKey(resolvedMappings) {
	return function (key, resolvedValue) {
		resolvedMappings.set(key, resolvedValue);
	};
}
